export default "__VITE_ASSET__D31$CMiW__"